
function base(locale: string) {
    return `${locale}/legal`;
}

export const navMap = {
    locale: (locale: string) => ({
        legal: () => `/${base(locale)}`,
        newCase: () => `/${base(locale)}/newCase`,
        library: () => `/${base(locale)}/library`,
        caseId : (caseId: string) => ({
            menu: () => `/${base(locale)}/${caseId}`,
            repo: () => `/${base(locale)}/${caseId}/repo`,
            chat: () => `/${base(locale)}/${caseId}/chat`,
            summary: () => `/${base(locale)}/${caseId}/summary`,
            smartSearch: () => `/${base(locale)}/${caseId}/smart-search`,
            documents: () => ({
                base: () => `/${base(locale)}/${caseId}/documents`,
                template: () => `/${base(locale)}/${caseId}/documents/template`,
                creator: () => `/${base(locale)}/${caseId}/documents/creator`
            })
        }),
        licenceIssue: () => `/${base(locale)}/licenceIssue`,
        accountIssue: () => `/${base(locale)}/accountIssue`,
        signedOut: () => `/${base(locale)}/signedOut`,
        login: () => `/${base(locale)}/auth/login`,
        admin : () => ({
            menu: () => `/${locale}/admin`,
            llmEndpoints: () => ({
                base: () => `/${locale}/admin/llm-endpoints`,
                create: () => `/${locale}/admin/llm-endpoints/create`,
                edit: (id: string) => `/${locale}/admin/llm-endpoints/edit/${id}`
            }),
            connections: () => ({
                base: () => `/${locale}/admin/connections`,
                create: () => `/${locale}/admin/connections/create`,
                edit: (id: string) => `/${locale}/admin/connections/edit/${id}`
            }),
        }),
    })
};
